import React from "react";
import { motion } from "framer-motion";
import { Cake, Tent, GraduationCap, Briefcase, Sparkles } from "lucide-react";
import { EVENTS_GRID } from "../../lib/site-data";

const ICONS = [Cake, Tent, GraduationCap, Briefcase, Sparkles];

export const Events = () => {
    return (
        <section id="events" data-testid="events-section" className="py-20 sm:py-24 bg-brand-cream relative">
            <div className="max-w-7xl mx-auto px-6 sm:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
                    <div>
                        <p className="text-xs tracking-[0.25em] uppercase text-brand-coral mb-3">Where I shine</p>
                        <h2 className="font-display text-3xl sm:text-5xl text-brand-ink leading-[1.05] max-w-2xl">
                            Perfect for any <em className="text-brand-coral">celebration</em>.
                        </h2>
                    </div>
                    <p className="md:max-w-md text-sm text-brand-inkSoft leading-relaxed">
                        From an intimate gathering to a bustling community festival,
                        I bring the right setup, energy, and supplies.
                    </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
                    {EVENTS_GRID.map((e, i) => {
                        const Icon = ICONS[i % ICONS.length];
                        return (
                            <motion.div
                                key={e.title}
                                initial={{ opacity: 0, y: 12 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-40px" }}
                                transition={{ duration: 0.45, delay: i * 0.05 }}
                                whileHover={{ y: -3 }}
                                className="group bg-white rounded-2xl border border-brand-border p-4 sm:p-5 hover:border-brand-coral hover:shadow-md transition-all"
                                data-testid={`event-card-${i}`}
                            >
                                <span className="h-9 w-9 rounded-lg bg-brand-coral/10 flex items-center justify-center group-hover:bg-brand-coral/20 transition-colors mb-3">
                                    <Icon className="h-4 w-4 text-brand-coral" strokeWidth={1.7} />
                                </span>
                                <h3 className="font-display text-lg text-brand-ink leading-tight">{e.title}</h3>
                                <p className="text-xs text-brand-inkSoft mt-1 leading-relaxed">{e.desc}</p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Events;
